import { useLocation, useNavigate, useParams } from "react-router-dom";
import style from "./Receipt.module.css";
import { useContext, useEffect, useState } from "react";
import { requester } from "App";
import { AuthContext } from "providers/AuthProvider";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Center from "layouts/wrapper/Center";
import P from "components/P";
import { formatLocalDate } from "shared/utils/Utils";
import Dummy from "components/Dummy";
import NiceModal from "@ebay/nice-modal-react";
import BackButton from "components/buttons/BackButton";

function Receipt() {

    const { userId, userName } = useContext(AuthContext);
    const { id } = useParams();
    const [orderList, setOrderList] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        if (userId) {
            let data = {
                storeId: id
            }
            requester.findAllPurchaseOrder(data, (result) => {
                
                setOrderList(result.data);
            })
        }


    }, [userId])

    const onReceiptDetailClick = (data) => {
        // NiceModal.show("receiptDetail", { data: data });
        navigate(`/ws/${id}/mobile/receipt/detail/${data.id}`, { state: { data: data } })
    }


    return (
        <div style={{ height: "95vh" }}>
            <div style={{ backgroundColor: "#F0F1F3" }}>
                <Dummy height={"50px"} />
                <VerticalFlex gap={10} padding={10}>
                    <FlexChild justifyContent={"center"}>
                        <P size={16} weight={"bold"}>구입내역</P>
                        <Dummy width={"30px"} />
                    </FlexChild>
                    <FlexChild backgroundColor={"white"}>
                        {
                            orderList &&
                                orderList.length > 0
                                ?
                                orderList.map((data, index) => (

                                    <VerticalFlex gap={15}>
                                        <FlexChild width={"100%"} height={"1px"} backgroundColor={"#D9D9D9"} />
                                        <FlexChild height={"max-content"}>
                                            <div onClick={() => onReceiptDetailClick(data)}>
                                                <HorizontalFlex>
                                                    <FlexChild width={"30%"}>
                                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "5px" }}>
                                                            {/* <img src={data.productImg} width={"60%"} /> */}
                                                            <img src={data.orderProducts[0] && data.orderProducts[0].productImg} width={"60%"} />
                                                        </div>
                                                    </FlexChild>
                                                    <FlexChild>
                                                        <VerticalFlex>
                                                            <FlexChild width={"100%"}>
                                                                <HorizontalFlex padding={"0 10px 0 0"}>
                                                                    <FlexChild width={"80%"} justifyContent={"flex-start"}>
                                                                        <Center textAlign={"left"} width={"100%"}>
                                                                            <P>{formatLocalDate(data.orderProducts[0] && data.orderProducts[0].createDateTime)} 관저점</P>
                                                                        </Center>
                                                                    </FlexChild>
                                                                    <FlexChild justifyContent={"flex-end"}>
                                                                        <P color={"#aaa"}>더보기</P>
                                                                    </FlexChild>
                                                                </HorizontalFlex>
                                                            </FlexChild>
                                                            <FlexChild>
                                                                <Center textAlign={"left"} width={"100%"}>
                                                                    <P>{data.orderProducts[0] && data.orderProducts[0].productName} 외 {data.orderProducts && data.orderProducts.length - 1}건</P>
                                                                </Center>
                                                            </FlexChild>
                                                            <FlexChild>
                                                                <Center textAlign={"left"} width={"100%"}>
                                                                    <P font={"gmarketSansBold"}>{data.amount ? data.amount.toLocaleString() : "0"}원</P>
                                                                </Center>
                                                            </FlexChild>
                                                        </VerticalFlex>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </div>
                                        </FlexChild>
                                        <FlexChild width={"100%"} height={"1px"} backgroundColor={"#D9D9D9"} />
                                    </VerticalFlex>

                                ))
                                :
                                <FlexChild padding={30}>
                                    <Center>
                                        <P>구입내역이 없습니다</P>
                                    </Center>
                                </FlexChild>

                        }
                    </FlexChild>


                </VerticalFlex>
                <Dummy height={"12vh"} />
            </div>

        </div >
    );
}

export default Receipt;